export const navigationTranslations = {
  NAVIGATION_OPERATOR_BUTTON_TEXT: 'Doe mee als vervoerder!'
}
